// Define categories based on company descriptions
export const categories = [
  'All',
  'Fintech',
  'Mobility',
  'Enterprise',
  'Healthcare',
  'Education',
  'E-commerce',
  'Community',
];

export interface Company {
  name: string;
  description: string;
  category: string;
  website: string;
  logo?: string; // Optional logo URL
}

export const companies: Company[] = [
  {
    name: 'OLA',
    description:
      'Ride-hailing and mobility platform transforming urban transportation.',
    category: 'Mobility',
    website: 'https://www.olacabs.com',
    logo: '/logos/ola-logo.png',
  },
  {
    name: 'Whatfix',
    description:
      'Digital adoption platform enhancing user engagement for enterprise software.',
    category: 'Enterprise',
    website: 'https://www.whatfix.com',
    logo: '/logos/Whatfix.png',
  },
  {
    name: 'Porter',
    description:
      'Tech-enabled logistics platform for intracity goods transportation.',
    category: 'Mobility',
    website: 'https://www.porter.in',
    logo: '/logos/Porter.png',
  },
  {
    name: 'Jupiter',
    description:
      'Neobank simplifying personal finance and banking for young Indians.',
    category: 'Fintech',
    website: 'https://www.jupiter.money',
    logo: '/logos/Jupiter.png',
  },
  {
    name: 'Rupeek',
    description:
      'Gold loan platform offering secure and hassle-free financing.',
    category: 'Fintech',
    website: 'https://www.rupeek.com',
    logo: '/logos/Rupeek.png',
  },
  {
    name: 'Rapido',
    description:
      'Bike taxi and logistics service for cost-effective urban commutes.',
    category: 'Mobility',
    website: 'https://www.rapido.bike',
    logo: '/logos/Rapido.png',
  },
  {
    name: 'Melorra',
    description:
      'Online jewelry brand offering trendy, lightweight designs for daily wear.',
    category: 'E-commerce',
    website: 'https://www.melorra.com',
    logo: '/logos/Melorra.png',
  },
  {
    name: 'Fareye',
    description:
      'SaaS platform for optimizing last-mile logistics and delivery management.',
    category: 'Enterprise',
    website: 'https://www.fareye.com',
    logo: '/logos/Fareye.png',
  },
  {
    name: 'Agnikul',
    description:
      'Aerospace startup developing customizable and small satellite launch vehicles.',
    category: 'Enterprise',
    website: 'https://www.agnikul.in',
    logo: '/logos/Agnikul.png',
  },
  {
    name: 'MediBuddy',
    description:
      'Digital healthcare platform providing teleconsultation, diagnostics, and e-pharmacy services.',
    category: 'Healthcare',
    website: 'https://www.medibuddy.in',
    logo: '/logos/MediBuddy.png',
  },
  {
    name: 'Chalo',
    description:
      'App-based platform improving public transportation through live tracking and digital ticketing.',
    category: 'Mobility',
    website: 'https://www.chalo.com',
    logo: '/logos/Chalo.png',
  },
  {
    name: 'Pixis',
    description:
      'AI-powered marketing optimization platform for demand generation.',
    category: 'Enterprise',
    website: 'https://www.pixis.ai',
    logo: '/logos/Pixis.png',
  },
  {
    name: 'Bigbasket',
    description:
      'Online grocery delivery platform offering a wide range of products.',
    category: 'E-commerce',
    website: 'https://www.bigbasket.com',
    logo: '/logos/Bigbasket.png',
  },
  {
    name: 'Wysa',
    description:
      'AI-driven mental health app providing self-care tools and professional therapy.',
    category: 'Healthcare',
    website: 'https://www.wysa.com',
    logo: '/logos/Wysa.png',
  },
  {
    name: 'Grip Invest',
    description:
      'Alternative investment platform for fractional ownership in physical assets.',
    category: 'Fintech',
    website: 'https://www.gripinvest.in',
    logo: '/logos/Grip_Invest.png',
  },
  {
    name: 'Mudrex',
    description:
      'Simplified crypto investment platform offering curated investment products.',
    category: 'Fintech',
    website: 'https://mudrex.com/',
    logo: '/logos/Mudrex.png',
  },
  {
    name: 'Raise',
    description:
      'Innovative employee benefits and rewards management platform.',
    category: 'Enterprise',
    website: 'https://raiseholding.co/',
    logo: '/logos/Raise.png',
  },
  {
    name: 'Animall',
    description:
      'Marketplace connecting farmers for trading cattle and livestock.',
    category: 'E-commerce',
    website: 'https://www.animall.in',
    logo: '/logos/Animall.png',
  },
  {
    name: 'Basic Home Loans',
    description:
      'Tech-driven platform simplifying the home loan process for Indian customers.',
    category: 'Fintech',
    website: 'https://www.basichomeloan.com/',
    logo: '/logos/Basic_Home_Loans.png',
  },
  {
    name: 'TradeX',
    description:
      'Social trading platform for prediction-based investment opportunities.',
    category: 'Fintech',
    website: 'https://www.tradexapp.co/',
    logo: '/logos/TradeX.png',
  },
  {
    name: 'StockGro',
    description:
      'Virtual stock trading and social investment learning platform.',
    category: 'Fintech',
    website: 'https://www.stockgro.club/',
    logo: '/logos/StockGro.png',
  },
  {
    name: 'GoKwik',
    description:
      'E-commerce enabler focusing on increasing conversion rates and reducing RTO.',
    category: 'E-commerce',
    website: 'https://www.gokwik.co/',
    logo: '/logos/GoKwik.png',
  },
  {
    name: 'Quizzizz',
    description: 'Interactive platform for gamified quizzes and assessments.',
    category: 'Education',
    website: 'https://www.quizzizz.com',
    logo: '/logos/Quizzizz.png',
  },
  {
    name: 'Grayquest',
    description:
      'Education financing platform offering monthly payment options for school fees.',
    category: 'Education',
    website: 'https://www.grayquest.com',
    logo: '/logos/Grayquest.png',
  },
  {
    name: 'Fab Hotels',
    description:
      'Asset-light hotel aggregation platform offering affordable stays.',
    category: 'Enterprise',
    website: 'https://www.fabhotels.com',
    logo: '/logos/Fab_Hotels.png',
  },
  {
    name: 'Rigi',
    description:
      'Creator economy enabler providing monetization tools for digital content creators.',
    category: 'Community',
    website: 'https://www.rigi.club',
    logo: '/logos/Rigi.png',
  },
  {
    name: 'Apps for Bharat',
    description:
      'Spiritual and devotional app platform catering to Indian audiences.',
    category: 'Community',
    website: 'https://www.appsforbharat.com',
    logo: '/logos/Apps_for_Bharat.png',
  },
  {
    name: 'OneImpression',
    description:
      'Influencer marketing platform connecting brands with creators.',
    category: 'Community',
    website: 'https://www.oneimpression.io',
    logo: '/logos/OneImpression.png',
  },
  {
    name: 'Lysto',
    description:
      'Web3 platform for creating, sharing, and trading gaming credentials and NFTs.',
    category: 'Community',
    website: 'https://www.lysto.io',
    logo: '/logos/Lysto.png',
  },
  {
    name: 'Cityflo',
    description: 'Premium bus service for daily urban commuters.',
    category: 'Mobility',
    website: 'https://www.cityflo.com',
    logo: '/logos/Cityflo.png',
  },
  {
    name: 'Nua',
    description:
      'Women-focused wellness brand offering period care and intimate hygiene products.',
    category: 'Healthcare',
    website: 'https://nuawoman.com',
    logo: '/logos/Nua.png',
  },
  {
    name: 'Flinto',
    description: 'Subscription-based learning activity kits for children.',
    category: 'Education',
    website: 'https://parenting.flinto.in/',
    logo: '/logos/Flinto.png',
  },
  {
    name: 'Zingbus',
    description:
      'Intercity bus aggregator offering affordable and reliable travel options.',
    category: 'Mobility',
    website: 'https://www.zingbus.com',
    logo: '/logos/Zingbus.png',
  },
  {
    name: 'Coverself',
    description:
      'Health insurance infrastructure platform providing API-based solutions.',
    category: 'Healthcare',
    website: 'https://www.coverself.com',
    logo: '/logos/Coverself.png',
  },
  {
    name: 'ElectricPe',
    description:
      'EV charging and payment platform for accelerating green mobility.',
    category: 'Mobility',
    website: 'https://www.electricpe.com',
    logo: '/logos/ElectricPe.png',
  },
  {
    name: 'Vidyut',
    description: 'Electric vehicle financing and marketplace platform.',
    category: 'Mobility',
    website: 'https://www.vidyuttech.in/',
    logo: '/logos/Vidyut.png',
  },
  {
    name: 'Zeni',
    description: 'AI-powered finance management platform for startups.',
    category: 'Fintech',
    website: 'https://www.zeni.ai',
    logo: '/logos/Zeni.png',
  },
  {
    name: 'BizzTM',
    description:
      'Hyperlocal e-commerce platform connecting small businesses with customers.',
    category: 'E-commerce',
    website: 'https://www.bizztm.com',
    logo: '/logos/BizzTM.png',
  },
  {
    name: '91sqfeet',
    description:
      'Platform simplifying retail store expansion with end-to-end solutions.',
    category: 'Enterprise',
    website: 'https://91squarefeet.com/',
    logo: '/logos/91sqfeet.png',
  },
  {
    name: 'NxtWave',
    description:
      'Edtech platform providing industry-relevant upskilling for students and professionals.',
    category: 'Education',
    website: 'https://www.ccbp.in',
    logo: '/logos/NxtWave.png',
  },
  {
    name: 'Kalvi',
    description:
      'Immersive learning platform integrating work and study programs.',
    category: 'Education',
    website: 'https://www.kalvieducation.com',
    logo: '/logos/Kalvi.png',
  },
  {
    name: 'Healofy',
    description:
      "Community-driven platform for parenting and women's health advice.",
    category: 'Community',
    website: 'https://www.healofy.com',
    logo: '/logos/Healofy.png',
  },
  {
    name: 'LIO',
    description: 'Personal productivity app for organizing and managing data.',
    category: 'Enterprise',
    website: 'https://www.lio.io',
    logo: '/logos/LIO.png',
  },
  {
    name: 'Yojak',
    description:
      'B2B marketplace connecting manufacturers with retailers in the construction industry.',
    category: 'E-commerce',
    website: 'https://www.yojak.in',
    logo: '/logos/Yojak.png',
  },
  {
    name: 'MyHQ',
    description: 'Flexible coworking spaces for professionals and teams.',
    category: 'Enterprise',
    website: 'https://www.myhq.in',
    logo: '/logos/MyHQ.png',
  },
  {
    name: 'VS Mani',
    description: 'Premium South Indian packaged foods brand.',
    category: 'E-commerce',
    website: 'https://www.vsmani.com',
    logo: '/logos/vsmani.png',
  },
  {
    name: 'Cashbook',
    description:
      'Simple app for managing cash transactions for small businesses.',
    category: 'Fintech',
    website: 'https://www.cashbook.in',
    logo: '/logos/Cashbook.png',
  },
  {
    name: 'LetsVenture',
    description:
      'Platform connecting startups with angel investors and venture capital.',
    category: 'Fintech',
    website: 'https://www.letsventure.com',
    logo: '/logos/LetsVenture.png',
  },
  {
    name: 'Refrens',
    description:
      'Invoice and payment management platform for freelancers and small businesses.',
    category: 'Fintech',
    website: 'https://www.refrens.com',
    logo: '/logos/Refrens.png',
  },
  {
    name: 'BharatX',
    description: 'Embedded credit platform for consumer-focused businesses.',
    category: 'Fintech',
    website: 'https://www.bharatx.tech',
    logo: '/logos/BharatX.png',
  },
  {
    name: 'ASQI',
    description:
      'Platform providing enterprise-grade software quality assurance solutions.',
    category: 'Enterprise',
    website: 'https://asqi.in/',
    logo: '/logos/ASQI.png',
  },
  {
    name: 'Depo24',
    description: 'B2B Marketplace for construction materials',
    category: 'E-commerce',
    website: 'https://www.depo24.in',
    logo: '/logos/Depo24.png',
  },
  {
    name: 'LikeMinds',
    description:
      'Community management SaaS platform for building and scaling online communities.',
    category: 'Community',
    website: 'https://www.likeminds.community',
    logo: '/logos/LikeMinds.png',
  },
  {
    name: 'HyperTest',
    description:
      'Intelligent testing platform for end-to-end software quality assurance.',
    category: 'Enterprise',
    website: 'https://www.hypertest.co',
    logo: '/logos/HyperTest.png',
  },
  {
    name: 'Economize',
    description: 'Cloud cost optimization platform for enterprises.',
    category: 'Enterprise',
    website: 'https://www.economize.cloud',
    logo: '/logos/Economize.png',
  },
  {
    name: 'Karban Fans',
    description: 'Sustainable and energy-efficient fan manufacturing brand.',
    category: 'Enterprise',
    website: 'https://www.karban.in',
    logo: '/logos/Karban_Fans.png',
  },
  {
    name: 'Mitigata',
    description: 'Cloud based cyber security provider',
    category: 'Enterprise',
    website: 'https://www.mitigata.com',
    logo: '/logos/mitigata-logo.png',
  },
  {
    name: 'Grid',
    description:
      'ODM platform offering custom manufacturing solutions for electronics and allied industries.',
    category: 'Enterprise',
    website: 'https://www.grid-os.com',
    logo: '/logos/Grid.png',
  },
  {
    name: 'Allter',
    description:
      'A company providing biodegradable and eco-friendly baby products.',
    category: 'E-commerce',
    website: 'https://letsallter.com/',
    logo: '/logos/allter.png',
  },
  {
    name: 'Bimaplan',
    description:
      'An insurtech company providing affordable and accessible insurance solutions.',
    category: 'Fintech',
    website: 'https://bimaplan.co',
    logo: '/logos/Bimaplan.png',
  },
  {
    name: 'Bindbee',
    description: 'Unified API for HR Tools.',
    category: 'Enterprise',
    website: 'https://www.bindbee.dev',
    logo: '/logos/bindbee.png',
  },
  {
    name: 'Canvaloop',
    description:
      'A sustainable textile company producing eco-friendly fabrics from agricultural waste.',
    category: 'Enterprise',
    website: 'https://www.canvaloop.com',
    logo: '/logos/Canvaloop.png',
  },
  {
    name: 'CloudWorx',
    description:
      'A platform offering cloud-based solutions for businesses to enhance productivity.',
    category: 'Enterprise',
    website: 'https://www.cloudworx.ai',
    logo: '/logos/CloudWorx.png',
  },
  {
    name: 'CosIQ',
    description:
      'A skincare brand focusing on science-backed, effective products.',
    category: 'Healthcare',
    website: 'https://mycosiq.com/',
    logo: '/logos/cosiq.png',
  },
  {
    name: 'CureSkin',
    description:
      'An AI-driven skincare app offering personalized treatment plans and products.',
    category: 'Healthcare',
    website: 'https://www.cureskin.com',
    logo: '/logos/CureSkin.png',
  },
  {
    name: 'Decode Age',
    description:
      'A healthtech startup focusing on longevity and age-related wellness solutions.',
    category: 'Healthcare',
    website: 'https://www.decodeage.com',
    logo: '/logos/Decode_Age.png',
  },
  {
    name: 'Dharaksha Ecosolutions',
    description:
      'A company creating sustainable packaging solutions from agricultural waste.',
    category: 'Enterprise',
    website: 'https://www.dharaksha.com',
    logo: '/logos/Dharaksha_Ecosolutions.png',
  },
  {
    name: 'FabAlley',
    description:
      'An online fashion retailer offering trendy apparel and accessories for women.',
    category: 'E-commerce',
    website: 'https://www.faballey.com',
    logo: '/logos/FabAlley.png',
  },
  {
    name: 'Frontpage',
    description:
      'A social news platform that aggregates and curates content from various sources.',
    category: 'Community',
    website: 'https://front.page',
    logo: '/logos/Frontpage.png',
  },
  {
    name: 'HackerEarth',
    description:
      'A platform for developers to practice coding, participate in challenges, and connect with employers.',
    category: 'Education',
    website: 'https://www.hackerearth.com',
    logo: '/logos/HackerEarth.png',
  },
  {
    name: 'Hair Originals',
    description:
      'A brand providing premium, ethically sourced human hair extensions.',
    category: 'E-commerce',
    website: 'https://www.hairoriginals.com',
    logo: '/logos/Hair_Originals.png',
  },
  {
    name: 'Homestrap',
    description:
      'A home organization brand providing storage solutions and accessories.',
    category: 'E-commerce',
    website: 'https://www.homestrap.com/',
    logo: '/logos/homestrap.png',
  },
  {
    name: 'Inspirit VR',
    description: 'Interactive STEM education via AR and VR',
    category: 'Education',
    website: 'https://inspiritvr.com',
    logo: '/logos/Inspirit_VR.png',
  },
  {
    name: 'Junio',
    description:
      'A smart card and app designed to teach kids financial literacy and money management.',
    category: 'Fintech',
    website: 'https://www.junio.in',
    logo: '/logos/Junio.png',
  },
  {
    name: 'Meragi',
    description:
      'A company offering end-to-end wedding planning and design services.',
    category: 'Community',
    website: 'https://www.meragi.com',
    logo: '/logos/Meragi.png',
  },
  {
    name: 'Nasher Miles',
    description:
      'A travel brand offering a range of stylish and durable luggage.',
    category: 'E-commerce',
    website: 'https://www.nashermiles.com',
    logo: '/logos/Nasher_Miles.png',
  },
  {
    name: 'Neosapien',
    description:
      'A technology firm specializing in artificial intelligence and machine learning solutions.',
    category: 'Enterprise',
    website: 'https://www.neosapien.ai',
    logo: '/logos/neosapien.png',
  },
  {
    name: 'P-TAL',
    description:
      'A brand reviving traditional metal crafts to create contemporary kitchenware.',
    category: 'E-commerce',
    website: 'https://www.ptal.in',
    logo: '/logos/P-TAL.png',
  },
  {
    name: 'Punt Partners',
    description:
      'A digital marketing agency specializing in performance-driven strategies.',
    category: 'Enterprise',
    website: 'https://punt.partners',
    logo: '/logos/Punt_Partners.png',
  },
  {
    name: 'Revamp Moto',
    description:
      'An electric vehicle startup developing sustainable mobility solutions.',
    category: 'Mobility',
    website: 'https://www.revampmoto.in',
    logo: '/logos/Revamp_Moto.png',
  },
  {
    name: 'Seekho',
    description:
      'A learning platform providing short, skill-based courses to enhance professional development.',
    category: 'Education',
    website: 'https://seekho.in',
    logo: '/logos/Seekho.png',
  },
  {
    name: 'Sharmaji Ka Aata',
    description:
      'A brand delivering freshly milled, high-quality flour to consumers.',
    category: 'E-commerce',
    website: 'https://www.sharmajikaaata.com',
    logo: '/logos/Sharmaji_Ka_Aata.png',
  },
  {
    name: 'Skippi Ice Pop',
    description:
      'A brand offering a range of flavored ice pops made from natural ingredients.',
    category: 'E-commerce',
    website: 'https://www.skippiicepops.com',
    logo: '/logos/Skippi_Ice_Pop.png',
  },
  {
    name: 'Sunfox Technologies',
    description:
      'A medical device company developing portable diagnostic tools.',
    category: 'Healthcare',
    website: 'https://www.sunfox.in',
    logo: '/logos/Sunfox_Technologies.png',
  },
  {
    name: 'Superleap',
    description: 'AI Native CRM',
    category: 'Enterprise',
    website: 'https://www.superleap.com',
    logo: '/logos/superleap-logo.png',
  },
  {
    name: 'The Honest Home Company',
    description:
      'A brand dedicated to creating non-toxic, eco-friendly home cleaning products.',
    category: 'E-commerce',
    website: 'https://honesthome.in',
    logo: '/logos/The_Honest_Home_Company.png',
  },
  {
    name: 'The Yarn Bazaar',
    description:
      'A B2B platform connecting yarn buyers and sellers for efficient trading.',
    category: 'E-commerce',
    website: 'https://www.theyarnbazaar.com',
    logo: '/logos/The_Yarn_Bazaar.png',
  },
  {
    name: 'Thinkerbell Labs',
    description:
      'An edtech company creating innovative learning tools for the visually impaired.',
    category: 'Education',
    website: 'https://www.thinkerbelllabs.com',
    logo: '/logos/Thinkerbell_Labs.png',
  },
  {
    name: 'WedMeGood',
    description:
      'A wedding planning platform connecting couples with vendors and providing inspiration.',
    category: 'Community',
    website: 'https://www.wedmegood.com',
    logo: '/logos/WedMeGood.png',
  },
  {
    name: 'Whatsup Wellness',
    description: 'A wellness brand offering health supplements and products.',
    category: 'Healthcare',
    website: 'https://www.whatsupwellness.in',
    logo: '/logos/Whatsup_Wellness.png',
  },
  {
    name: 'Winston',
    description: 'A personal care brand offering grooming products for men.',
    category: 'E-commerce',
    website: 'https://www.winstonindia.com',
    logo: '/logos/Winston.png',
  },
  {
    name: 'Wiselife',
    description:
      'A lifestyle brand offering eco-friendly and sustainable household products.',
    category: 'E-commerce',
    website: 'https://www.wiselife.in',
    logo: '/logos/Wiselife.png',
  },
];
